import {
  HttpClient
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DataSessionService } from '../../../core/services/data-session.service';
import { USER_INT_DOMAIN } from '../../../core/constants/constants';
import {
  RegistrationUserData,
  RegistrerResponse,
} from '../type/registration';
import { LoginResponse, LoginUserData } from '../type/login';
import { ResetPasswordBody, ResetPasswordResponse, ResetPasswordRestoreBody } from '../type/password';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private readonly _router = inject(Router);
  private readonly _http = inject(HttpClient);
  private readonly _dataSessionService = inject(DataSessionService);
  private readonly defaultErrorMessage: string = 'generic';

  private readonly errorMessage: Record<string, string> = {
    EXC01: 'login.error-internal-user',
    EXC02: 'login.wrong-user',
    EXC03: 'login.reset-user',
    EXC04: 'login.pending-user',
    EXC05: 'login.denied-user',
  };

  getErrorMessage(error: keyof typeof this.errorMessage): string {
    return this.errorMessage[error] || this.defaultErrorMessage;
  }

  private readonly statusType: Record<string, string> = {
    EXC03: 'registerSuccess',
    EXC04: 'registerPending',
    EXC05: 'registerRejected',
    EXC06: 'registerActive',
  };

  getRegisterStatus(state: keyof typeof this.statusType): AuthVerifMapKeys {
    return this.statusType[state] as AuthVerifMapKeys;
  }

  private readonly statusPassType: Record<string, string> = {
    EXC01: 'tokenCaducado',
    EXC02: 'tokenUsed',
    EXC03: 'tokenPassSuccess',
    EXC05: 'tokenPassError',
  };

  getPassStatus(state: keyof typeof this.statusType): AuthVerifMapKeys {
    return this.statusPassType[state] as AuthVerifMapKeys;
  }

  isInternalUserDomain(userData: string): boolean {
    const domain = userData.split('@')[1];
    return USER_INT_DOMAIN.some((allowedDomain) => domain?.includes(allowedDomain));
  }

  validateToken(token: string): Observable<string> {
    return of('caducado');
}

  postRegister = (body: RegistrationUserData): Observable<RegistrerResponse> =>
    this._http.post<RegistrerResponse>(
      `${this._dataSessionService.baseUrl}/register`,
      body
    );

  postLogin = (body: LoginUserData): Observable<LoginResponse> =>
    this._http.post<LoginResponse>(`${this._dataSessionService.baseUrl}/login`, body);

  postResetPassword = (body: ResetPasswordBody): Observable<ResetPasswordResponse> =>
    this._http.post<ResetPasswordResponse>(`${this._dataSessionService.baseUrl}/reset-password`, body);

  postResetPasswordRestore = (body: ResetPasswordRestoreBody): Observable<ResetPasswordResponse> =>
    this._http.post<ResetPasswordResponse>(`${this._dataSessionService.baseUrl}/reset-password-restore`, body);
}
